import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
import { toNano } from "@ton/core";
export default {
  name: "nftLucky",
  computed: {
    ...walletVuex.mapState(["tonConnect"]),
    ...taskVuex.mapState(["timerObjs"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      speed: 50,
      totalSteps: 0,
      maxSteps: 0,
      order: [0, 1, 2, 5, 8, 7, 6, 3],
      // 顺时针索引
      highlightIndex: null,
      // 当前高亮项（从0-8）
      winningIndex: 6,
      // ✅ 中奖项：真实格子索引（不是顺时针顺序里的位置）

      luckyInfo: null,
      luckyLogs: null,
      luckyPage: {
        page: 1,
        limit: 50,
        loading: false,
        finished: false
      },
      prizeList: [],
      isBtnLoading: false,
      prizeAllResult: null,
      isResultAnim: false,
      isPageLoading: true,
      isRefresh: false,
      popStockEnoughShow: false,
      priceList: {
        base: {
          price_coin: 0,
          price_stock: 0,
          price_tap: 0,
          price_stars: 0,
          price_ton: 0,
          isLoading: false,
          deposit_id: null
        },
        stars: {
          price_coin: 0,
          price_stock: 0,
          price_tap: 0,
          price_stars: 0,
          price_ton: 0,
          isLoading: false,
          deposit_id: null
        },
        ton: {
          price_coin: 0,
          price_stock: 0,
          price_tap: 0,
          price_stars: 0,
          price_ton: 0,
          isLoading: false,
          deposit_id: null
        }
      },
      popRewardShow: false,
      rewardData: null,
      NFTBalance: 0,
      rowKey: null,
      isCheckBtn: false,
      insufficientBalanceShow: false,
      insufficientStarOrTonBalanceShow: false,
      isCheckLoading: false,
      isStart: false
    };
  },
  methods: {
    ...userVuex.mapMutations(["setUserData"]),
    async showReward() {
      const data = this.prizeAllResult.winning_item;
      console.log("datadatadata", data);
      this.rewardData = {
        count: data.amount,
        balance: this.NFTBalance
      };
      await this.getNFTBalance();
      this.setUserData(this.prizeAllResult.user);
      this.$refs.nNewHeadRef && this.$refs.nNewHeadRef.refreshFnc();
      this.rewardData = {
        ...this.rewardData,
        newBalance: this.NFTBalance
      };
      console.log("this.$parent.rewardData", this.rewardData);
      await this.getLuckyLogsFnc(false);
      this.$nextTick(() => {
        this.popRewardShow = true;
        this.priceList[this.rowKey].isLoading = false;
        this.isCheckLoading = false;
        this.isStart = false;
        this.isCheckBtn = false;
      });
    },
    async getNFTBalance() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/nft/fragment/balance", {
          provider: "official",
          type: 3
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.NFTBalance = data.balance;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async onStart(key, val) {
      const result = Object.entries(this.priceList).some(([k, item]) => {
        const isOtherLoading = k !== key && item.isLoading;
        if (isOtherLoading) console.log(`跳过了因为 ${k} 正在加载`);
        return isOtherLoading;
      });
      if (result) return;
      if (this.isStart) return;
      this.rowKey = key;
      const balances = this.$refs?.nNewHeadRef.balance;
      console.log("val=========star", key, val, balances, val.price_stars, val.price_ton, val.price_stars > balances.Stars.balance, val.price_ton > balances.ton.balance);
      if (key == "base" && (val.price_coin >= 0 && val.price_coin > balances.coin.balance || val.price_stock >= 0 && val.price_stock > balances.stock.balance || val.price_tap >= 0 && val.price_tap > balances.tap.balance)) {
        this.insufficientBalanceShow = true;
        return;
      } else if (key == "stars" && val.price_stars > balances.Stars.balance || key == "ton" && val.price_ton > balances.ton.balance) {
        this.insufficientStarOrTonBalanceShow = true;
        return;
      }
      if (this.priceList[this.rowKey].isLoading) return;
      this.priceList[this.rowKey].isLoading = true;
      if (this.rowKey == "ton" || this.rowKey == "stars") {
        await this.onPayment();
      } else {
        let params = {
          lotteryId: this.luckyInfo.id,
          priceType: this.rowKey == "base" ? null : this.rowKey
        };
        const res = await this.getLuckyResult(params);
        if (!res) {
          this.priceList[this.rowKey].isLoading = false;
          return;
        }
        this.insufficientStarOrTonBalanceShow = false;
        this.prizeAllResult = res;
        this.startSpin();
      }
    },
    async onDeposit() {
      if (this.priceList[this.rowKey].isLoading) return;
      this.priceList[this.rowKey].isLoading = true;
      if (this.rowKey == "ton" || this.rowKey == "stars") {
        await this.onPayment();
      } else {
        const res = await this.getLuckyResult(params);
        if (!res) {
          this.priceList[this.rowKey].isLoading = false;
          return;
        }
        this.priceList[this.rowKey].isLoading = false;
        this.insufficientStarOrTonBalanceShow = false;
        this.prizeAllResult = res;
        this.startSpin();
      }
    },
    async onPayment() {
      const fnc = async () => {
        // let params = {
        //   orderId: resp?.chainInfo?.deposit_id,
        //   action: "deposit",
        // };
        let params = {
          lotteryId: this.luckyInfo.id,
          priceType: this.rowKey == "base" ? null : this.rowKey
        };
        if (this.rowKey == "ton") {
          params["address"] = this.tonWallet.uiAddress;
        }
        const res = await this.getLuckyResult(params);
        if (!res) {
          this.priceList[this.rowKey].isLoading = false;
          return;
        }
        console.log("resresresres", res);
        if (this.rowKey == "ton" && res?.chainInfo) {
          let msg = [{
            address: res.chainInfo.contract,
            amount: toNano(res.chainInfo.amount).toString(),
            payload: res.chainInfo.raw
          }];
          console.log("msgmsgmsgmsgmsgmsg", msg);
          const payRef = await _v.tonWallet.sendTransaction(msg);
          console.log("payRefpayRef123", payRef);
          if (!payRef) {
            this.priceList[this.rowKey].isLoading = false;
            console.log("this.priceList[this.rowKey]", this.priceList[this.rowKey]);
            return;
          }
          this.priceList[this.rowKey].deposit_id = res?.chainInfo.deposit_id;
          this.isCheckBtn = true;
          const upRes = await this.popCheckStarsOrTon(9);
          console.log("upRes123", upRes);
          this.isCheckBtn = false;
          if (!upRes) return;
          this.priceList[this.rowKey].deposit_id = null;
          await fnc();
        } else if (this.rowKey == "stars" && res?.chainInfo) {
          const payRef = await this.openInvoiceStarPay({
            url: res.chainInfo.payment_url
          });
          if (!payRef) {
            this.priceList[this.rowKey].isLoading = false;
            console.log("this.priceList[this.rowKey]111", this.priceList[this.rowKey]);
            return;
          }
          this.isCheckBtn = true;
          this.priceList[this.rowKey].deposit_id = res?.chainInfo.deposit_id;
          const upRes = await this.popCheckStarsOrTon(3);
          this.isCheckBtn = false;
          if (!upRes) return;
          this.priceList[this.rowKey].deposit_id = null;
          await fnc();
        } else {
          this.insufficientStarOrTonBalanceShow = false;
          this.prizeAllResult = res;
          this.startSpin();
        }
      };
      this.$nextTick(() => {
        if (this.rowKey === "ton" && !this.tonConnect) {
          this.$nextTick(() => {
            this.tonWallet.openOrCloseTonModal(true);
            this.tonWallet.ton.onStatusChange(async walletAndwalletInfo => {
              this.tonWallet.getWalletInfo();
              if (this.tonWallet.ton.connected) {
                this.priceList[this.rowKey].isLoading = true;
                setTimeout(() => {
                  fnc();
                }, 1000);
              } else {
                this.priceList[this.rowKey].isLoading = false;
              }
            });
          });
        } else {
          fnc();
        }
      });
    },
    async popCheckStarsOrTon(time = 1) {
      return new Promise(async resolve => {
        const fnc = async () => {
          this.timerObjs.NFTPage.NFTLuckyTimer = setTimeout(async () => {
            let params = {
              orderId: this.priceList[this.rowKey].deposit_id,
              action: "deposit"
            };
            const res = await _v.$http.post("/user/assets/order/check", params);
            if (!res) {
              this.$toasted.error("Deposit failed, please try again");
              resolve();
            } else if (res.data.status == 1) {
              clearTimeout(this.timerObjs.NFTPage.NFTLuckyTimer);
              await fnc();
            } else if (res.data.status == 2) {
              clearTimeout(this.timerObjs.NFTPage.NFTLuckyTimer);
              resolve(res);
            } else {
              clearTimeout(this.timerObjs.NFTPage.NFTLuckyTimer);
              this.$toasted.error(res.message);
              resolve();
            }
          }, time * 1000);
        };
        await fnc();
      });
    },
    async onPayCheckBtn() {
      if (this.isCheckLoading) return;
      this.isCheckLoading = true;
      let params = {
        orderId: this.priceList[this.rowKey].deposit_id,
        action: "deposit"
      };
      const res = await _v.$http.post("/user/assets/order/check", params);
      if (!res) {
        this.isCheckLoading = false;
        this.$toasted.error("Deposit failed, please try again");
        return;
      } else if (res.data.status == 1) {
        this.isCheckLoading = false;
        this.$toasted.error(res.message);
        return;
      } else if (res.data.status == 2) {
        clearTimeout(this.timerObjs.NFTPage.NFTLuckyTimer);
        this.insufficientStarOrTonBalanceShow = false;
        await this.onPayment();
        return;
      } else {
        this.isCheckLoading = false;
        this.$toasted.error(res.message);
        return;
      }
    },
    //星星支付
    openInvoiceStarPay: async params => {
      return new Promise(async resolve => {
        try {
          const res = await _v.WebApp.openInvoice(params.url);
          async function invoiceClosedFnc(e) {
            _v.WebApp.offEvent("invoiceClosed", invoiceClosedFnc);
            console.log("ressssssss", res, e?.status);
            if (e?.status && e.status == "paid") {
              resolve(1);
            } else if (e?.status && e.status === "cancelled") {
              resolve();
            }
          }
          _v.WebApp.onEvent("invoiceClosed", invoiceClosedFnc);
        } catch (err) {
          console.log("err====", err);
        }
      });
    },
    startSpin() {
      this.isStart = true;
      const fastRounds = 4; // 快速转几圈
      const slowRounds = 3; // 最后慢速转两圈
      this.winningIndex = this.prizeList.findIndex(item => item.id == this.prizeAllResult.winning_item.id);
      const targetPos = this.order.findIndex(i => i === this.winningIndex); // 中奖在顺时针中的位置

      this.totalSteps = 0;
      this.speed = 30; // 起始速度
      this.currentIndex = 0;
      this.maxSteps = (fastRounds + slowRounds) * this.order.length + targetPos;
      this.timer = setInterval(this.runSpin, this.speed);
    },
    runSpin() {
      const items = this.order;
      this.currentIndex = (this.currentIndex + 1) % items.length;
      this.highlightIndex = items[this.currentIndex];
      this.totalSteps++;
      const slowDownStart = this.maxSteps - this.order.length * 2; // 慢速开始点
      const stepsLeft = this.maxSteps - this.totalSteps;
      if (this.totalSteps >= slowDownStart) {
        // 每步增加一点速度（越靠近结束越慢）
        this.speed += 30;
      }

      // 到达目标，结束
      if (this.totalSteps >= this.maxSteps) {
        clearInterval(this.timer);
        this.timer = null;
        this.showReward();
        return;
      }

      // 更新下一个 interval
      clearInterval(this.timer);
      this.timer = setInterval(this.runSpin, this.speed);
    },
    popRewardFinish() {
      if (!this.priceList[this.rowKey]) {
        return;
      }
      this.priceList[this.rowKey].isLoading = false;
    },
    setPriceList(item) {
      this.priceList.base.price_coin = item.price_coin;
      this.priceList.base.price_stock = item.price_stock;
      this.priceList.base.price_tap = item.price_tap;
      this.priceList.base.price_stars = item?.price_stars;
      this.priceList.base.price_ton = item?.price_ton;
      if (JSON.stringify(item.price_extras) !== "{}") {
        for (const key in item.price_extras) {
          this.priceList[key] = {
            ...item.price_extras[key],
            isLoading: false,
            deposit_id: null
          };
        }
      }
    },
    setActivityConfig() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/list", {
          provider: "official",
          type: 4
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            this.luckyInfo = {};
          } else {
            this.luckyInfo = data[0];
            this.setPriceList(this.luckyInfo);
          }
          resolve(this.luckyInfo);
        }, () => {
          resolve();
        });
      });
    },
    setLuckyList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/items", {
          lotteryId: this.luckyInfo.id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            resolve();
            return;
          }
          this.prizeList = [];
          data.forEach((item, index) => {
            this.prizeList.push({
              ...item,
              id: item.id,
              type: item.currency
            });
          });
          this.prizeList.splice(4, 0, "");
          console.log("this.prizeListthis.prizeList", this.prizeList);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    getLuckyResult(params) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/draw", params);
        if (res.code == 0) {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (!data) {
            this.$toasted.clear();
            this.$toasted.error(res.message);
            resolve();
            return;
          }
          resolve(data);
        } else {
          if (res.code === 404) {
            this.initFnc();
            resolve();
            return;
          }
          this.$toasted.clear();
          this.$toasted.error(res.message);
        }
      });
    },
    getLuckyLogs(params) {
      return new Promise(async resolve => {
        if (this.luckyInfo?.id) {
          const res = await _v.$http.post("/lucky/lottery/logs", {
            lotteryId: this.luckyInfo.id,
            ...params
          });
          vailcode(res, () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          }, () => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    async initFnc() {
      this.isPageLoading = true;
      const config = await this.setActivityConfig();
      if (!config) {
        this.isRefresh = false;
        return;
      }
      const items = await this.setLuckyList();
      if (!items) {
        this.isRefresh = false;
        return;
      }
      await this.getNFTBalance();
      await this.getLuckyLogsFnc(false);
      this.isPageLoading = false;
      console.log("itemsitemsitemsitemsitems", items);
    },
    async onRefresh() {
      this.isRefresh = true;
      await this.initFnc();
      if (JSON.stringify(this.luckyInfo) == "{}") {
        this.$toasted.clear();
        this.$toasted.info("Under maintenance!");
      }
    },
    async getLuckyLogsFnc(isPage) {
      this.luckyPage.page++;
      if (!isPage) {
        this.luckyLogs = [];
        this.luckyPage.page = 1;
      }
      const params = {
        page: this.luckyPage.page,
        limit: this.luckyPage.limit
      };
      this.luckyPage.loading = true;
      const res = await this.getLuckyLogs(params);
      if (res) {
        this.luckyPage.total = res.total;
        this.luckyLogs.push(...res.items);
        this.luckyPage.finished = this.luckyLogs.length >= this.luckyPage.total; // 没有更多数据
        this.luckyPage.loading = false;
      }
    },
    async handleScroll() {
      if (this.luckyPage.loading || this.luckyPage.finished) return;
      // 获取页面滚动的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 判断是否接近页面底部（距离底部100px以内时触发加载更多）
      if (scrollTop + windowHeight + 1 >= documentHeight) {
        await this.getLuckyLogsFnc(true);
      }
    }
  },
  mounted() {
    this.initFnc();
    window.addEventListener("scroll", this.handleScroll.bind(this));
  },
  beforeRouteLeave(to, from, next) {
    try {
      window.removeEventListener("scroll", this.handleScroll.bind(this));
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  }
};